export default {"src":"/_next/static/media/contactUsHeaderIcon.4bcf972b.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};